import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../../typography'
import Image from '../../image'

import { useBreakpoint } from '../../../../hooks/breakpoint'

import Certificate from '../../../../public/img/bantrab/decoration-certification.png'

const Certifications = ({ ...attrs }) => {
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'pt-8',
      'pb-10',
      'md:pt-12',
      'md:pb-16',
      'md:bg-white'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          'absolute',
          'top-0',
          'left-0',
          'w-full',
          'h-full',
          'bg-green-600',
          'overflow-hidden'
        ])
      }
      style={{
        borderRadius: breakpoint.mdAndUp ? '0 0 5rem 5rem' : '0'
      }}>
    </div>
    <div
      className={
        classNames([
          'relative',
          'container',
          'px-4'
        ])
      }>
      <div
        className={
          classNames([
            'flex',
            'flex-row',
            'flex-wrap',
            'justify-center',
            '-mx-4'
          ])
        }>
        <div
          className={
            classNames([
              'relative',
              'p-4',
              'flex',
              'flex-col',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <Typography
            weight={'bold'}
            size={breakpoint.mdAndUp ? 'eight' : 'six'}
            className={'text-white mb-4'}>
            Certificado digital Crehana y Brantrab
          </Typography>
          <Typography
            size={breakpoint.mdAndUp ? 'three' : 'two'}
            className={'text-white mb-4'}>
            Sube el proyecto final de cada curso para ser calificado por tus profesores. De esa forma, al terminar la especialización, tendrás un portafolio completo y aprobado para obtener tu diploma.
          </Typography>
        </div>
        <div
          className={
            classNames([
              'relative',
              'p-4',
              'relative',
              'flex',
              'flex-col',
              'justify-center',
              'items-center'
            ])
          }
          style={{
            flexBasis: breakpoint.mdAndUp ? '50%' : '100%'
          }}>
          <Image
            src={Certificate}
            style={{
              width: 'auto',
              height: '100%'
            }} />
        </div>
      </div>
    </div>
  </section >
}

Certifications.propTypes = {
  title: PropTypes.string,
  highlightedTitleText: PropTypes.string,
  text: PropTypes.string
}
export default Certifications
